<template>
  <tr>
    <td class="c-table__cell--center c-table__cell--middle">{{ deliverDate }}<br />{{ deliverTime }}</td>
    <td class="c-table__cell--left c-table__cell--middle">
      <p class="u-w360 u-text-ellipsis">{{ scenario.scenario_name }}</p>
    </td>
    <td class="c-table__cell--center c-table__cell--middle">{{ stepCount }}</td>
    <td class="c-table__cell--center c-table__cell--middle">
      <template v-if="(scenario.scenario_status != stepInfo.scenarioStatusValues.Wait) && (scenario.scenario_status != stepInfo.scenarioStatusValues.Stop)">
        {{ stepInfo.scenarioStatuses[scenario.scenario_status] }}
      </template>

      <template v-if="(scenario.scenario_status == stepInfo.scenarioStatusValues.Wait) || (scenario.scenario_status == stepInfo.scenarioStatusValues.Stop)">
        <div class="c-btn-slide" :class="{'is-active': isWaiting}"  @click="onStatusChangeClick">
          <div class="c-btn-slide__text">配信中</div>
          <div class="c-btn-slide__text">停止中</div>
        </div>
      </template>
    </td>
    <td class="c-table__cell--center c-table__cell--middle">
      <ul class="c-table-editable-list">
        <li v-if="canEdit" class="c-table-editable-list__item">
          <a class="c-btn c-btn--gray-3 c-btn--circle" @click="onEditClick">
            <div class="c-btn__text c-btn__text--balloon">編集する</div>
            <div class="c-icon c-icon--gray-3 u-wh20"><svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
            </div>
          </a>
        </li>
        <li v-if="!canEdit" class="c-table-editable-list__item">
          <a class="c-btn c-btn--gray-3 c-btn--circle" @click="onReviewClick">
            <div class="c-btn__text c-btn__text--balloon">確認する</div>
            <div class="c-icon c-icon--gray-3 u-wh20"><svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <use xlink:href="/assets/img/sprite.svg#review" />
            </svg>
            </div>
          </a>
        </li>
        <li class="c-table-editable-list__item">
          <a class="c-btn c-btn--gray-3 c-btn--circle" @click="onDeleteClick">
            <div class="c-btn__text c-btn__text--balloon">削除する</div>
            <div class="c-icon c-icon--gray-3 u-wh20"><svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <use xlink:href="/assets/img/sprite.svg#trash" />
            </svg>
            </div>
          </a>
        </li>
      </ul>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    scenario: Object,
    stepInfo: Object,
  },
  emits: ["delete-click","edit-click","result-click","review-click","status-change-click"],
  computed: {
    firstMessage: function () {
      let message = null;
      if (this.scenario && this.scenario.scenario_messages.length > 0) {
        message = this.scenario.scenario_messages[0].message;
      }
      return message;
    },
    deliverDate: function() {
      let deliverDate = '';
      let message = this.firstMessage;
      if(message && message.message_deliver){
        deliverDate = this.getDisplayDate(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
    deliverTime: function() {
      let deliverDate = '';
      let message = this.firstMessage;
      if(message && message.message_deliver){
        deliverDate = this.getDisplayTime(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
    isWaiting: function() {
      return this.scenario.scenario_status == this.stepInfo.scenarioStatusValues.Wait;
    },
    stepCount: function () {
      // シナリオに含まれる総ステップ数
      return this.scenario && this.scenario.scenario_messages
        ? this.scenario.scenario_messages.length
        : 0;
    },
    // 全メッセージが「配信済み」のシナリオは、scenario_status が Wait に戻っていても
    // 編集→再配信フローを開いても 1 通目の予約日時を再設定する画面を経由できないため
    // 過去日時のまま「配信待ち」状態に陥る。設計上の再配信動線が無いので編集ボタンを出さない。
    allMessagesCompleted: function () {
      const completeValue = this.stepInfo
        && this.stepInfo.deliverStatusValues
        && this.stepInfo.deliverStatusValues.Complete;
      if (!completeValue) {
        return false;
      }
      if (!this.scenario || !this.scenario.scenario_messages || this.scenario.scenario_messages.length === 0) {
        return false;
      }
      return this.scenario.scenario_messages.every(function (sm) {
        return sm && sm.message && sm.message.deliver_status == completeValue;
      });
    },
    canEdit: function () {
      if (this.scenario.scenario_status == this.stepInfo.scenarioStatusValues.Complete) {
        return false;
      }
      return !this.allMessagesCompleted;
    },
  },
  mounted: function() {
  },
  methods: {
    onDeleteClick: function () {
      this.$emit('delete-click', this.scenario);
    },
    onEditClick: function () {
      this.$emit('edit-click', this.scenario.scenario_id);
    },
    onResultClick: function () {
      this.$emit('result-click', this.scenario.scenario_id);
    },
    onReviewClick: function () {
      this.$emit('review-click', this.scenario.scenario_id);
    },
    onStatusChangeClick: function () {
      this.$emit('status-change-click', this.scenario);
    },
  },
};
</script>
